import React from "react";
// import { Link } from "react-router-dom";
import thankimgs from "../../utils/images/thank-imgs.svg";
import whatsapp from "../../utils/images/whatsapp.svg";
import copyshareicon from "../../utils/images/copy-share-icon.svg";
import telegramicon from "../../utils/images/telegram-icon.svg";
import Emailicon2 from "../../utils/images/Email-icon2.svg";
import "bootstrap/dist/css/bootstrap.css";

function ThankYouLandingInfluencers(props) {
  return (
    <div className="main-wrapper" id="thank-you">
      <div className="container">
        <div className="thankyou-img">
          <img src={thankimgs} alt="" />
        </div>
        <div className="thankyou-content text-center">
          <h2 className="thank-youb d-none d-md-block">
            Welcome to SumoEats, Influencers Titan!
          </h2>
          <h2 className="thank-youb d-block d-md-none">
            Welcome to the SumoEats Family,
          </h2>
          <p>
	  Thanks for signing up — you’re now officially onboard as a SumoEats Influencer. We’re excited to work with you and can’t wait to bring you creator-only perks, takeaway partnerships, and campaign opportunities as we roll out our soft launch.
          </p>
        </div>
        <div className="thankyou-box">
          <div className="container">
            <div className="text-center">
              <h2>Stay Ready, Stay Tuned!</h2>
              <p>
	  Know other creators who’d be a great fit? Share SumoEats and help us build the UK’s go-to food creator network.
              </p>
              <ul>
                <li>
                  <a
                    href="https://wa.me/?text=https://sumoeats.co.uk/influencers"
                    target="_blank"
                  >
                    <img src={whatsapp} alt="" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/share/url?url=https://sumoeats.co.uk/influencers"
                    target="_blank"
                  >
                    <img src={telegramicon} alt="" />
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:hello@sumoeats.co.uk&amp;subject=Sumoeats&amp;body=I wanna be Sumohttps://sumoeats.co.uk/influencers"
                    target="_blank"
                  >
                    <img src={Emailicon2} alt="" />
                  </a>
                </li>
                <li>
                  <img
                    src={copyshareicon}
                    alt=""
                    onClick={() =>
                      navigator.clipboard.writeText(
                        "https://sumoeats.co.uk/influencers"
                      )
                    }
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThankYouLandingInfluencers;
